import Service from "../../Service";
import Vue from "vue";
const resource = "ResponsibleSupervisor/";

export default {
    save(prd, requestID) {
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    getSupervisorsWithFarms(requestID, zonId = null,sizeType = null, typePartner = null) {
        const params = { requestID };
        if (zonId) params.zonId = zonId;
        if (sizeType) params.sizeType = sizeType;
        if (typePartner) params.typePartner = typePartner;
        return Service.get(resource + "list-with-farms", {
            params: params,
        });
    },
};
